import { render } from "./KeHoachTable.vue?vue&type=template&id=f892887a&ts=true"
import script from "./KeHoachTable.vue?vue&type=script&lang=ts"
export * from "./KeHoachTable.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__